module.exports = __webpack_public_path__ + "img/BCAA_newpkg-thumb-510x510-1421_04.6fbd2e6f.png";